import { fromJS } from "immutable";
import { replacer } from "../../../../../../utils/replacer";
import { mergeArray, flattenArr } from "../../../../../../utils/commonUtil";
import {
  setExchangeIntoTiffType,
  setInputValuesType,
  valueExchangeFromTiffType,
  setStepOneType,
  setStepTwoType,
  selectTiffOptionType,
  setPoolModalFalseType,
  resetFlowType,
  updateFromAmountType,
  resetInitialFlowType,
  editModeType,
  disableFromType,
  valueInFormChangeType,
  submitDataSuccessType,
  tiffExchangeSuccessType,
  tiffInfoSavedType,
  getTiffDataLoaderType,
  getTiffDataSuccessType,
  getExpectedExchangeDataLoaderType,
  getExpectedExchangeDataSuccessType,
  tiffDisclaimerSavedType,
  getAllPoolsLoaderType,
  getAllPoolsSuccessType,
  getPoolsInfoLoaderType,
  getPoolsInfoSuccessType,
  accountDataReceivedSuccessType,
  accountDataReceivedFromSuccessType,
  allPoolDataFromSuccessType,
  beforeSubmitLoaderType,
  afterSubmitLoaderType
} from '../../actionTypes'

const initialState = fromJS({
  tiffPoolName: "TIFF Multi-Asset Pool",
  selectTiffOption: "",
  fromPool: {
    data: null,
    isLoading: true
  },
  tiffExchangeAmount: 0,
  valueTiffExchangeAmount: null,
  allPoolData: {
    data: [],
    isLoading: true
  },
  poolInfoData: {
    data: {},
    isLoading: true
  },
  stepOne: {},
  stepOneSet: false,
  stepTwo: {},
  stepTwoSet: false,
  tiffInfo: {
    data: null,
    isLoading: true
  },
  viewEditTiff: {
    isLoading: true,
    data: {},
    error: ""
  },
  exchangeAmount: null,
  expectedEchangeDate: {
    isLoading: true,
    data: {},
    error: ""
  },
  tiffDisclaimer: null,
  poolData: {
    singlePool: null,
    singleUF: null,
    modalPool: false,
    modalUF: false
  },
  isDisabled: false,
  intoTotal: 0,
  stepTwoUserData: {
    isLoading: true,
    data: [],
    error: ""
  },
  toFrom: {
    isLoading: true,
    data: [],
    error: ""
  },
  accountData: {
    isLoading: true,
    data: [],
    error: ""
  },
  submitTransactionId: null,
  formDataSubmitted: false,
  fromTiffPoolDetails: {},
  toTiffPoolDetails: {},
  disableFromOption: "",
  valueInFormChange: false,
  beforeSubmitData: {
    isLoading: true,
    data: {},
    error: ""
  },
  afterSubmitData: {
    isLoading: true,
    data: {},
    error: ""
  },
});

const tiffExchange = (state = initialState, action) => {
  switch (action.type) {
    case selectTiffOptionType:
      return state.set("selectTiffOption", action.payload);

    case setExchangeIntoTiffType: {
      let obj = {};
      const fromPool = [];
      let tiffExchangeAmount = 0;
      var isFromPresent = null;
      const tiffPoolName = state.get("tiffPoolName");
      action.payload.map(pool => {
        if (pool.poolName !== tiffPoolName) {
          const value = replacer(pool.poolName);
          obj = {
            poolId: pool.poolId,
            pool: pool.poolName,
            [`${value}`]: ""
          };
          fromPool.push(obj);
        } else {
          tiffExchangeAmount = pool.availableBalance;
        }
        return true;
      });
      var tiffArray = action.payload.filter(item => {
        return item.poolName === "TIFF Multi-Asset Pool"
      });
      if (tiffArray && tiffArray.length < 1) {
        isFromPresent = true;
      } else {
        isFromPresent = false;
      }
      return state
        .setIn(["fromPool", "data"], fromPool)
        .setIn(["fromPool", "isLoading"], false)
        .set("disableFromOption", isFromPresent)
        .set("tiffExchangeAmount", tiffExchangeAmount);
    }

    case setInputValuesType: {
      const array = state.getIn(["fromPool", "data"]);
      const newArray = [];
      array.map(obj => {
        if (obj.hasOwnProperty(action.payload.key)) {
          obj[action.payload.key] = action.payload.value;
        }
        newArray.push(obj);
        return true;
      });
      return state.setIn(["fromPool", "data"], newArray);
    }

    case valueExchangeFromTiffType:
      return state.set("valueTiffExchangeAmount", action.payload);

    case setStepOneType:
      const fromTiffPool = state.getIn(["fromTiffPoolDetails"]);
      if (action.payload.valueTiffExchangeAmount) {
        fromTiffPool[0].value = action.payload.valueTiffExchangeAmount;
      }
      return state
        .set("stepOne", action.payload)
        .set("stepOneSet", true)
        .setIn(["fromTiffPoolDetails"], fromTiffPool);

    case setStepTwoType:
      return state.set("stepTwo", action.payload).set("stepTwoSet", true);

    case tiffInfoSavedType:
      const fromData = action.payload.exchangeFrom.filter(
        pool => pool.poolName === "TIFF Multi-Asset Pool"
      );
      const toData = action.payload.exchangeTo.filter(
        pool => pool.poolName === "TIFF Multi-Asset Pool"
      );
      if(toData.length> 0) {
        toData[0].value = 100;
       }
      return state
        .setIn(["tiffInfo", "data"], action.payload)
        .setIn(["tiffInfo", "isLoading"], false)
        .setIn(["fromTiffPoolDetails"], fromData)
        .setIn(["toTiffPoolDetails"], toData)
        .set("formDataSubmitted", false);

    case getTiffDataSuccessType:
      var data = action.payload.singleExchange;
      var type = "";
      var amount = null;
      var availableBalance = null;
      var intoTotal = null;
      data.exchangeFrom.map(item => {
        if (item.pool === "TIFF Multi-Asset Pool") {
          type = "exchangeFromTIFF";
        }
      });
      data.exchangeTo.map(item => {
        if (item.pool === "TIFF Multi-Asset Pool") {
          type = "exchangeintoTIFF";
        }
      });
      if (type == "exchangeFromTIFF") {
        data.exchangeFrom.map(item => {
          if (item.pool === "TIFF Multi-Asset Pool") {
            amount = item.value;
            availableBalance = item.availableBalance;
          }
        });
      } else {
        data.exchangeFrom.map(item => {
          if (item.pool !== "TIFF Multi-Asset Pool") {
            intoTotal += Number(item.value);
          }
        });
      }
      return state
        .setIn(["viewEditTiff", "data"], action.payload)
        .setIn(["viewEditTiff", "isLoading"], false)
        .setIn(["selectTiffOption"], type)
        .setIn(["exchangeAmount"], amount)
        .setIn(["intoTotal"], intoTotal)
        .setIn(["stepOne", "valueTiffExchangeAmount"], amount)
        .setIn(["stepOne", "tiffAvailableBalance"], availableBalance);

    case getTiffDataLoaderType:
      return state.setIn(["viewEditTiff", "isLoading"], true);

    case getExpectedExchangeDataSuccessType:
      return state
        .setIn(["expectedEchangeDate", "data"], action.payload)
        .setIn(["expectedEchangeDate", "isLoading"], false);
    case getExpectedExchangeDataLoaderType:
      return state.setIn(["expectedEchangeDate", "isLoading"], true);

    case tiffDisclaimerSavedType:
      return state.set("tiffDisclaimer", action.payload);

    case "POOL_DATA_SUCCESS":
      return state.setIn(["poolData", "singlePool"], action.payload);

    case "UNDERLYING_DATA_SUCCESS":
      return state.setIn(["poolData", "singleUF"], action.payload);

    case "POOL_DATA_SUCCESS_SET": {
      return state.setIn(["poolData", "modalPool"], action.payload);
    }

    case "UNDERLYING_DATA_SUCCESS_SET": {
      return state.setIn(["poolData", "modalUF"], action.payload);
    }

    case setPoolModalFalseType: {
      return state
        .setIn(["poolData", "modalUF"], action.payload)
        .setIn(["poolData", "modalPool"], action.payload);
    }

    case resetFlowType: {
      const disableFromOption = state.getIn(["disableFromOption"]);
      return state
        .set("selectTiffOption", "")
        .set("stepOne", {})
        .set("stepOneSet", false)
        .set("stepTwo", {})
        .set("stepTwoSet", false)
        .setIn(["isDisabled"], false)
        .set("disableFromOption", disableFromOption)
        .set("formDataSubmitted", false)
        .set("valueInFormChange", false)
        .setIn(["submitTransactionId"], null);
    }
    case resetInitialFlowType:
      const disableFromOption = state.getIn(["disableFromOption"]);
      return state
        .set("selectTiffOption", "")
        .set("stepOne", {})
        .set("stepOneSet", false)
        .set("stepTwo", {})
        .set("stepTwoSet", false)
        .set("exchangeAmount", null)
        .set("disableFromOption", disableFromOption)
        .set("formDataSubmitted", false)
        .set("valueInFormChange", false)
        .setIn(["submitTransactionId"], null);

    case editModeType:
      return state.setIn(["isDisabled"], true)
        .set("selectTiffOption", action.payload);

    case updateFromAmountType: {
      const exchangeFromData = state.getIn([
        "viewEditTiff",
        "data",
        "singleExchange",
        "exchangeFrom"
      ]);
      exchangeFromData.map(item => {
        if (item.pool === "TIFF Multi-Asset Pool") {
          item.value = action.payload;
        }
      });
      return state.setIn(
        [
          "tiffExchange",
          "viewEditTiff",
          "data",
          "singleExchange",
          "exchangeFromData"
        ],
        exchangeFromData
      );
    }

    case getAllPoolsSuccessType:
      return state
        .setIn(["allPoolData", "data"], action.payload)
        .setIn(["allPoolData", "isLoading"], false);
    case getAllPoolsLoaderType:
      return state.setIn(["allPoolData", "isLoading"], true);

    case getPoolsInfoSuccessType:
      return state
        .setIn(["poolInfoData", "data"], action.payload)
        .setIn(["poolInfoData", "isLoading"], false);
    case getPoolsInfoLoaderType:
      return state.setIn(["poolInfoData", "isLoading"], true);

    case accountDataReceivedSuccessType:
      return state
        .setIn(["accountData", "data"], action.payload)
        .setIn(["accountData", "isLoading"], false);

    /** step 2 merged data**/
    case accountDataReceivedFromSuccessType:
      return state
        .setIn(["stepTwoUserData", "data"], action.payload)
        .setIn(["stepTwoUserData", "isLoading"], false);

    case allPoolDataFromSuccessType: {
      let investPoolData = state.getIn([
        "stepTwoUserData",
        "data",
        "investmentPools"
      ]);
      return state
        .updateIn(["toFrom", "data"], () => {
          let allPoolData = flattenArr(action.payload);
          return mergeArray(investPoolData, allPoolData);
        })
        .setIn(["toFrom", "isLoading"], false);
    }

    case tiffExchangeSuccessType:
      return state.setIn(["submitTransactionId"], action.payload);

    case submitDataSuccessType:
      return state.setIn(["formDataSubmitted"], true);

    case disableFromType:
      return state.set("disableFromOption", action.payload);

    case valueInFormChangeType:
      return state.set("valueInFormChange", action.payload);

    case "BEFORE_SUBMIT_SUCCESS":
      return state
        .setIn(["beforeSubmitData", "data"], action.payload)
        .setIn(["beforeSubmitData", "isLoading"], false);
    case beforeSubmitLoaderType:
      return state.setIn(["beforeSubmitData", "isLoading"], true);

    case "AFTER_SUBMIT_SUCCESS":
      return state
        .setIn(["afterSubmitData", "data"], action.payload)
        .setIn(["afterSubmitData", "isLoading"], false);
    case afterSubmitLoaderType:
      return state.setIn(["afterSubmitData", "isLoading"], true);

    default:
      return state;
  }
};

export default tiffExchange;
